import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 45 45',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Icon" transform="translate(-134 -617)">
      <path
        fill={fill}
        id="path"
        d="M840.181,1227.631a1.733,1.733,0,0,1,.9,1.234,2,2,0,0,1-.258,1.508,2.084,2.084,0,0,1-1.161.96c-5.031,1.371-9.158,2.606-12.511,3.566l-6.836,1.92-2.064.686c-.258-.548-1.419-2.606-3.353-6.171l1.935-.549,2.58,2.057,6.449-1.783-5.288-9.874,2.451-.686,8.9,8.777,6.836-1.92A2.422,2.422,0,0,1,840.181,1227.631ZM815.8,1241.757H840.31v2.743H815.8Z"
        transform="translate(-671.134 -593)"
      />
      <g
        fill="none"
        id="Elipse_251"
        data-name="Elipse 251"
        transform="translate(134 617)"
        stroke={fill}
        strokeWidth="2"
      >
        <circle cx="22.5" cy="22.5" r="22.5" stroke="none" />
        <circle fill="none" cx="22.5" cy="22.5" r="21.5" />
      </g>
    </g>
  </svg>
);

export default SVG;
